module.exports = __webpack_public_path__ + "static/media/swimmyFacebook-1200x630.3ef21222.jpg";